__webpack_require__.p = "/games/BVD/default/bovada-roulette/";